import * as request from '@/utils/request'

const PREFIX_SHIFT = '/attendance_shift'
const PREFIX_GROUP = '/attendance_group'

export default {
  // 班次列表
  getShiftList(data) {
    return request.post(`${PREFIX_SHIFT}/list`, data)
  },
  // 新增班次
  createShift(data) {
    return request.post(`${PREFIX_SHIFT}/create`, data)
  },
  // 编辑班次
  updateShift(data) {
    return request.post(`${PREFIX_SHIFT}/update`, data)
  },
  // 保存班次（无 id 调 create，有 id 调 update）
  saveShift(data) {
    if (data && data.id) {
      return request.post(`${PREFIX_SHIFT}/update`, data)
    }
    return request.post(`${PREFIX_SHIFT}/create`, data)
  },
  // 班次详情（查看）
  getShiftInfo(id) {
    return request.post(`${PREFIX_SHIFT}/view`, { id })
  },
  // 班次编辑详情（编辑页用，readonly=false）
  getShiftEditView(id) {
    return request.post(`${PREFIX_SHIFT}/edit_view`, { id })
  },
  // 删除班次
  deleteShift(id) {
    return request.post(`${PREFIX_SHIFT}/delete`, { id })
  },
  // 班次状态切换
  updateShiftStatus(data) {
    return request.post(`${PREFIX_SHIFT}/status`, data)
  },

  // 考勤组列表
  getAttendanceGroupList(data) {
    return request.post(`${PREFIX_GROUP}/list`, data)
  },
  // 新增考勤组
  createAttendanceGroup(data) {
    return request.post(`${PREFIX_GROUP}/create`, data)
  },
  // 编辑考勤组
  updateAttendanceGroup(data) {
    return request.post(`${PREFIX_GROUP}/update`, data)
  },
  // 保存考勤组（无 id 调 create，有 id 调 update）
  saveAttendanceGroup(data) {
    if (data && data.id) {
      return request.post(`${PREFIX_GROUP}/update`, data)
    }
    return request.post(`${PREFIX_GROUP}/create`, data)
  },
  // 考勤组详情（查看）
  getAttendanceGroupInfo(id) {
    return request.post(`${PREFIX_GROUP}/view`, { id })
  },
  // 考勤组编辑详情（编辑页用）
  getAttendanceGroupEditView(id) {
    return request.post(`${PREFIX_GROUP}/edit_view`, { id })
  },
  // 删除考勤组
  deleteAttendanceGroup(id) {
    return request.post(`${PREFIX_GROUP}/delete`, { id })
  },
  // 考勤组状态切换
  updateAttendanceGroupStatus(data) {
    return request.post(`${PREFIX_GROUP}/status`, data)
  },
  // 任务可选项（考勤组绑定任务时下拉）
  getAttendanceGroupTaskOptions(data = {}) {
    return request.post(`${PREFIX_GROUP}/task_options`, data)
  },
  // 班次可选项（考勤组绑定班次时下拉）
  getAttendanceGroupShiftOptions(data = {}) {
    return request.post(`${PREFIX_GROUP}/shift_options`, data)
  },
  // 法定节假日日历
  getLegalHolidayCalendar(data = {}) {
    return request.post(`${PREFIX_GROUP}/legal_holiday_calendar`, data)
  },
}
